module.exports = __webpack_public_path__ + "media/icons/facebook-620da39a.png";